import { Injectable } from '@angular/core';
import JSZip from 'jszip';

import { LogService } from '../providers/index';

@Injectable({ providedIn: 'root' })
export class ZipService {
  public async unzip(file: Blob): Promise<{ data: Uint8Array<ArrayBuffer>; name: string }[]> {
    const jszip = new JSZip();

    const ret: { data: Uint8Array<ArrayBuffer>; name: string }[] = [];

    try {
      const extracted = await jszip.loadAsync(file);
      const files: JSZip.JSZipObject[] = Object.values(extracted.files);
      for (let i = 0, len = files.length; i < len; i++) {
        const file1 = files[i];
        const name1 = file1.name;
        const fileContent = jszip.file(name1);
        if (fileContent) {
          const uintFile = await fileContent.async('uint8array');
          // JSZip declares Uint8Array<ArrayBufferLike> because a SharedArrayBuffer would in principle
          // be possible; the library always allocates its output on a plain ArrayBuffer itself,
          // though. Narrowing the type here is cheaper than copying the array — for Bescheide with
          // many scanned pages that is double-digit megabytes per file.
          ret.push({
            name: name1,
            data: uintFile as Uint8Array<ArrayBuffer>,
          });
        }
      }
    } catch (e) {
      LogService.error(String(e));
    }
    return ret;
  }
}
